<template>
  <div class="table">
    <div class="container">
      <el-row>
        <el-button size="mini" type="primary" @click="historyBack">{{$t('common.close')}}</el-button>
        <!--关闭-->
      </el-row>
      <div class="handle-box">
        <el-form :model="headData" :label-position="labelPosition" ref="headDataForm" label-width="140px">
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item :label="$t('apply.no')">
                <!--单据编号-->
                <el-input class="handle-input" v-model="headData.applyNo" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('apply.applyType')" prop="applyType">
                <!--类型-->
                <el-select v-model="headData.applyType" :disabled="true" class="handle-input">
                  <el-option :key="index" v-for="(item,index) in applyTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('apply.subject')">
                <!--主题-->
                <el-input class="handle-input" v-model="headData.subject" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item :label="$t('apply.quotationType')" prop="quotationType">
                <!--报价类型-->
                <el-select v-model="headData.quotationType" class="handle-input" :disabled="true">
                  <el-option :key="index" v-for="(item,index) in quotationTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane :label="$t('apply.historyQuote')" name="line">
          <!--历史报价-->
          <div v-for="(round,i) in roundList" :key="i">
            <el-row :gutter="16">
              <!--轮次：-->
              <el-col :span="2">{{$t('apply.round')}}：</el-col>
              <el-col :span="1">{{round.roundNumber}}</el-col>
              <!--报价提交日期：-->
              <el-col :span="3">{{$t('apply.quoteSubmitDate')}}：</el-col>
              <el-col :span="3">
                <el-link> {{round.submitDate}} </el-link>
              </el-col>
              <!--轮次说明：-->
              <el-col :span="2">{{$t('apply.roundRemark')}}：</el-col>
              <el-col :span="4">{{round.remark}}</el-col>
              <!--轮次附件-->
              <el-col :span="2">
                <el-link type="primary" @click="showAttachmentDialogM(round.ttQuotationApplyRoundId)">{{$t('apply.roundAttachment')}}</el-link>
              </el-col>
              <!--报价附件-->
              <el-col :span="3">
                <el-link type="primary" @click="showQuotationAttachmentDialogM(round.ttQuotationId,round.supplierList)">{{$t('apply.quoteAttachment')}}</el-link>
              </el-col>
            </el-row>
            <el-table :data="round.quotationLineList" ref="quotationLineTableDataRef" :row-class-name="tableRowClassName" border class="table">
              <!--供应商-->
              <el-table-column show-overflow-tooltip prop="supplierName" fixed :label="$t('apply.supplier')" min-width="120px"></el-table-column>
              <!--发货市-->
              <el-table-column show-overflow-tooltip prop="pickupPoint" :label="$t('apply.shippingCity')" min-width="120px"></el-table-column>
              <!--到货仓库-->
              <el-table-column show-overflow-tooltip prop="dcName" :label="$t('apply.arrivalAarehouse')" min-width="120px"></el-table-column>
              <!--温区-->
              <!--原供应商-->
              <!--<el-table-column prop="originalSupplier" :label="$t('apply.originalSupplier')" min-width="160px"></el-table-column>-->
              <!--原价格-->
              <!--<el-table-column prop="originalPrice" :label="$t('apply.originalPrice')" min-width="160px"></el-table-column>-->
              <el-table-column show-overflow-tooltip prop="temperatureI18n" :label="$t('apply.temperature')" min-width="80px"></el-table-column>
              <!--结算单位-->
              <el-table-column show-overflow-tooltip prop="unit" :label="$t('apply.unit')" min-width="120px"></el-table-column>
              <!--运输方式-->
              <el-table-column show-overflow-tooltip prop="transportaionMethod" :label="$t('apply.transportaionMethod')" min-width="120px"></el-table-column>
              <!--有效开始日期-->
              <el-table-column show-overflow-tooltip prop="effectiveBeginDate" :label="$t('apply.effectiveBeginDate')" min-width="120px"></el-table-column>
              <!--线路报价（不含税）-->
              <el-table-column show-overflow-tooltip prop="price" :label="$t('apply.priceNotTax')" min-width="130px"></el-table-column>
              <!--现行线路价格-->
              <el-table-column show-overflow-tooltip prop="linePrice" :label="$t('apply.currentLinePrice')" min-width="120px"></el-table-column>
              <!--币种-->
              <el-table-column show-overflow-tooltip prop="currencyCode" :label="$t('apply.currency')" min-width="120px"></el-table-column>
              <el-table-column show-overflow-tooltip prop="leadTime" label="Leadtime" min-width="120px"></el-table-column>
              <!--预估年总费用-->
              <el-table-column show-overflow-tooltip prop="estimatedAnnualFee" :label="$t('apply.estimatedAnnualTotalCost')" min-width="130px"></el-table-column>
              <!--备注-->
              <el-table-column show-overflow-tooltip prop="remarks" :label="$t('common.remarks')" min-width="120px"></el-table-column>
              <!--报价确认审批状态-->
              <el-table-column show-overflow-tooltip prop="sourcingLineStatus" :label="$t('apply.sourcingApprovalStatus')" min-width="140px"></el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>

    </div>
    <!--轮次附件-->
    <el-dialog :title="$t('apply.roundAttachment')" :visible.sync="showRoundAttachmentDialog" append-to-body width="60%">
      <el-table :data="roundAttachmentList" border highlight-current-row class="table">
        <el-table-column sortable prop="documentName" :label="$t('common.file')" min-width="130px">
          <!--文件-->
          <template slot-scope="scope">
            <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
          </template>
        </el-table-column>
        <el-table-column sortable prop="userName" :label="$t('common.createBy')" min-width="130px"></el-table-column>
        <!--创建人-->
        <el-table-column sortable prop="createDate" :label="$t('common.createDate')" min-width="130px">
          <!--创建时间-->
          <template slot-scope="scope">
            {{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm")}}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog :title="$t('apply.quoteAttachment')" :visible.sync="showQuotationAttachmentDialog" append-to-body width="60%">
      <el-row align="middle" :gutter="10" v-for="(supplier,ix) in supplierList" :key="ix">
        <el-col :span="4">
          {{supplier.supplierName}}
        </el-col>
        <el-col :span="20">
          <el-table :data="fileList[ix]" border highlight-current-row class="table">
            <el-table-column sortable prop="documentName" :label="$t('common.file')" min-width="130px">
              <template slot-scope="scope">
                <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
              </template>
            </el-table-column>
            <el-table-column sortable prop="userName" :label="$t('common.createBy')" min-width="130px"></el-table-column>
            <el-table-column sortable prop="createDate" :label="$t('common.createDate')" min-width="130px">
              <template slot-scope="scope">
                {{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm")}}
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import { quotationService } from "../../../api/quotation-apply/quotation-service";
import { fileService } from "../../../api/common/file-utils";
import { inputChoiceService } from "../../../api/common/input-choice";
export default {
  name: 'quotation-history',
  data() {
    return {
      ttQuotationApplyId: null,
      labelPosition: 'right',
      headData: {},
      quotationLineTableData: [],
      applyTypeList: [],
      quotationTypeList: [],
      fileList: [],
      activeName: 'line',
      roundList: [],
      showRoundAttachmentDialog: false,
      roundAttachmentList: [],
      showQuotationAttachmentDialog: false,


      supplierList: [],
      showFileList: [],
    }
  },
  created() {
    this.getInputChoiceValues();
    this.quotationHistoryPageInitM(this.$route.params.applyId);
    this.ttQuotationApplyId = this.$route.params.applyId;
  },
  methods: {
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then((res) => { })
    },
    //文件列表数据获取
    showAttachmentDialogM: function (recId) {
      this.showRoundAttachmentDialog = true;
      let attachment = {};
      attachment.tsRecId = recId;
      attachment.tsReckindId = 'QUOTATION_APPLY_ROUND';
      fileService.getFileList(attachment).then((fileRes) => {
        this.roundAttachmentList = fileRes;
      })
    },
    showQuotationAttachmentDialogM: function (quotationId, supList) {
      let _this = this;
      _this.showQuotationAttachmentDialog = true;
      _this.supplierList = supList;
      //获取附件信息
      _this.showFileList = [];
      if (!!supList) {
        console.log(supList);
        supList.forEach((sup, inx) => {
          _this.showFileList.push([]);
          let attachment = {};
          attachment.tsRecId = quotationId;
          attachment.tsReckindId = 'QUOTATION';
          attachment.seq = sup.tmSupplierId + '';
          fileService.getFileList(attachment).then((fileRes) => {
            //this.showFileList.push(fileRes);
            _this.$set(_this.fileList, inx, fileRes);
          })
        })
      }
    },
    quotationHistoryPageInitM(applyId) {
      let _this = this;
      quotationService.quotationHistoryInit(applyId).then((res) => {
        _this.headData = res.quotationApply;
        _this.roundList = res.roundHistory;
      });
    },

    getInputChoiceValues: function () {
      let mapObj = {};
      mapObj["TT_QUOTATION_APPLY:APPLY_TYPE"] = "TT_QUOTATION_APPLY:APPLY_TYPE";
      mapObj["TT_QUOTATION_APPLY:QUOTATION_TYPE"] = "TT_QUOTATION_APPLY:QUOTATION_TYPE";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.applyTypeList = res["TT_QUOTATION_APPLY:APPLY_TYPE"];
        this.quotationTypeList = res["TT_QUOTATION_APPLY:QUOTATION_TYPE"];
      });
      inputChoiceService.getCurrencyList().then((res) => {
        this.currencyList = res;
      });
    },
    historyBack: function () {
      this.$router.replace({
        path: '/quotation'
      });
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.colour === 'Y') {
        return 'success-row-q';
      } else {
        return '';
      }
    }
  }
}
</script>
<style scoped>
.handle-box {
  margin-top: 20px;
}
.handle-input {
  width: 85%;
}

.handle-input-out {
  width: 70%;
}
.action-btn {
  margin-bottom: 10px;
}
.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}

.lineClass .el-form-item__label:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}

.el-table .success-row-q {
  background: #ffa796;
}
</style>
